export const testimonials = [
  {
    user: "瓜田里的守望者",
    role: "连续签到 180 天",
    content: "以前追热点要翻好几个群，现在直接来网爆吃瓜，梗图和神回复一次看全，转发速度比以前快多了。",
    likes: 1240,
  },
  {
    user: "打工人小张",
    role: "通勤党",
    content: "每天早上地铁上刷十五分钟，一天的班都变得好上一点。段子频道是我的固定打开项。",
    likes: 986,
  },
  {
    user: "半糖不加冰",
    role: "二创投稿者",
    content: "投过一次方言配音，没想到真的被放进视频频道了，还标了名字。这种被看见的感觉挺好的。",
    likes: 872,
  },
  {
    user: "评论区的课代表",
    role: "内容爱好者",
    content: "最喜欢看神回复频道，一条条读下来像是围观了一场高水平的对话比赛。",
    likes: 754,
  },
  {
    user: "会飞的鲸鱼",
    role: "表情包收藏家",
    content: "表情包分类做得很清楚，按场景找图特别快，群里斗图再也没输过。",
    likes: 631,
  },
  {
    user: "深夜冲浪选手",
    role: "夜猫子",
    content: "凌晨刷也不怕没内容，二创视频质量比想象中高，很多都值得反复看。",
    likes: 518,
  },
];